import { Logger } from "../utils/Logger/Logger.js";

export const BaseFormLogger = new Logger({
    tags: { category: "Forms" },
    prefixStrings: ["Form"],
    prefixStyles: [Logger.StylePresets.ButtonLabel({ 'background-color': "#639FAB" })]
});

export const SecondButtonDefaultStyle = Logger.StylePresets.ButtonLabel({ 'background-color': "#575761" });